import {err, ok, ValidationError} from 'framework';
import type {Result, Validator} from 'framework';
import * as z from 'zod';
import {SAVED_MEAL_DESCRIPTION_MAX, SAVED_MEAL_NAME_MAX} from '../../lib/constants';

export type SavedMealFormValues = {
  readonly name: string;
  readonly description: string;
};

export class CreateSavedMealDataValidator implements Validator<SavedMealFormValues> {
  readonly standardSchema = z
    .object({
      name: z.string().trim().min(1, 'Name is required.').max(SAVED_MEAL_NAME_MAX),
      description: z.string().trim().max(SAVED_MEAL_DESCRIPTION_MAX),
    })
    .strict();

  validate(value: unknown): Result<SavedMealFormValues, ValidationError> {
    const parsed = this.standardSchema.safeParse(value);
    if (!parsed.success) {
      return err(new ValidationError(parsed.error.issues[0]?.message ?? 'Invalid saved meal.'));
    }
    return ok(parsed.data);
  }
}
